import { useRouteContext } from '@lp/core/contexts/RouteContext';
import { LegLocationTypeEnum } from '@/api/apis/route';
import { getLocationAddress } from '@/utils/helpers';
import { useCountriesData } from '@/contexts/CountriesDataProvider';

type LocationItemProps = {
  locationId: string;
};

export const LocationItem = ({ locationId }: LocationItemProps) => {
  const { locationById } = useRouteContext();
  const { resolveSubdivisionName } = useCountriesData();
  const location = locationById.get(locationId);

  if (!location) return null;

  const getLocationDisplayName = () => {
    switch (location?.locationType) {
      case LegLocationTypeEnum.airport:
        return location.iata || location.icao;
      case LegLocationTypeEnum.hub:
        return location.code || 'HUB';
      case LegLocationTypeEnum.hospital:
        return 'DH';
      case LegLocationTypeEnum.txcenter:
        return 'TXC';
      default:
        return getLocationAddress(location.location, resolveSubdivisionName);
    }
  };

  return (
    <div
      className="font-mono px-1 bg-transparent border-1 rounded-xs text-s-sb"
      style={{ borderColor: '#0F8B99', color: '#0F8B99' }}
    >
      {getLocationDisplayName()}
    </div>
  );
};
